<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" class="inner-content">
  <main class="project-info" *ngIf="infra">
    <mat-grid-list cols="12" rowHeight="40">

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.LAST_EXECUTION" | translate }}</mat-label>
          <input
            matInput
            [value]="infra.lastExecution | date: 'dd/MM/yyyy hh:mm:ss'"
            disabled
          />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.NUM_ORGS" | translate }}</mat-label>
          <input matInput [value]="infra?.organizations?.length" disabled />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.DNS_PREFIX" | translate }}</mat-label>
          <input matInput [value]="infra.dnsPrefix" disabled />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.SUBNET_AKS_PREFIX" | translate }}</mat-label>
          <input matInput [value]="infra.subnetAksPrefix" disabled />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.SUBNET_STORAGE_PREFIX" | translate }}</mat-label>
          <input matInput [value]="infra.subnetStoragePrefix" disabled />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.NODE_TYPE_GLOBAL" | translate }}</mat-label>
          <input matInput [value]="infra.clusterNodeType" disabled />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.NODE_MIN_GLOBAL" | translate }}</mat-label>
          <input matInput [value]="infra.clusterMinAutoscaling" disabled />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.NODE_MAX_GLOBAL" | translate }}</mat-label>
          <input matInput [value]="infra.clusterMaxAutoscaling" disabled />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.NODE_TYPE_ORG" | translate }}</mat-label>
          <input matInput [value]="infra.workersNodeType" disabled />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.NODE_MIN_ORG" | translate }}</mat-label>
          <input matInput [value]="infra.workersMinAutoscaling" disabled />
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="4" [rowspan]="2">
        <mat-form-field>
          <mat-label>{{ "GLOBAL.NODE_MAX_ORG" | translate }}</mat-label>
          <input matInput [value]="infra.workersMaxAutoscaling" disabled />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </main>

  <mat-toolbar color="primary">
    <button mat-raised-button color="secondary" *ngIf="!infra">
      {{ "GLOBAL.INIT" | translate }}
    </button>
    
    <button mat-raised-button color="secondary" *ngIf="infra" (click)="navigateToCreateOrganization()">
      {{ "GLOBAL.NEW_ORG" | translate }}
    </button>
    
    <button class="delete-btn" mat-raised-button color="primary" (click)="deleteOrganization()" type="button">
      {{ "ORG_ADMIN.DELETE" | translate }}
    </button>

  </mat-toolbar>
</div>
